export default "__VITE_ASSET__9eba2bf1__"